import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * Toasts sit bottom-right at 13px and inherit the panel surface, so the one
 * floating element in the app that is not the command palette still looks like
 * it came from the same page.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      position="bottom-right"
      style={
        {
          '--normal-bg': 'var(--dy-card)',
          '--normal-text': 'var(--dy-fg)',
          '--normal-border': 'var(--dy-line)',
          '--border-radius': '0.375rem',
          '--width': '20rem',
          fontSize: '0.8125rem',
        } as React.CSSProperties
      }
      toastOptions={{ style: { boxShadow: 'var(--dy-pop-shadow)' } }}
      {...props}
    />
  );
};

export { Toaster };
